// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3NdSL","text":"SelectPayment_text__xGOmI","title":"SelectPayment_title__2l0Th","btn":"SelectPayment_btn__2gL2X"};